<template>
  <div class="customer">
    <div class="customer-main">
      <div class="customer-info">
        <p>
          <span
            v-if="detail.customerOrderFollowUpH24No == 1"
            style="color: red"
            >{{ detail.customerName }}</span
          >
          <span
            v-else-if="detail.customerOrderFollowUpColorValue == 1"
            style="color: green"
            >{{ detail.customerName }}</span
          >
          <span v-else>{{ detail.customerName }}</span>
        </p>
        <div class="region-info">
          <template
            v-if="
              Array.isArray(detail.customerOrg) && detail.customerOrg.length
            "
          >
            <span v-for="(item, index) in detail.customerOrg" :key="item.id">{{
              `${index ? "、" : ""}${item.orgName}` || "--"
            }}</span>
          </template>
          <span v-else>--</span>
        </div>
        <p>
          <span>跟进人</span>
          <span v-if="detail.followUpPerson">{{
            detail.followUpPerson.name || "--"
          }}</span>
        </p>
        <p>
          <span>课程服务人</span>
          <span v-if="detail.courseFollowUpPerson">{{
            detail.courseFollowUpPerson.name || "--"
          }}</span>
        </p>
        <p>
          <span>归属人</span>
          <span>{{ detail.parentName || "--" }}</span>
        </p>
        <p>
          <span>流量归属人</span>
          <span>{{ detail.flowPartnerName || "--" }}</span>
        </p>
        <p>
          <span>跟进时间</span>
          <span>{{ dateFormat(detail.followUpTime) || "--" }}</span>
        </p>
        <p>
          <span>手机号</span>
          <span>{{ detail.customerTel || "" }}</span>
        </p>
        <p>
          <span>微信号</span>
          <span>{{ detail.wechatNum || "" }}</span>
        </p>
        <p>
          <span>抖音号</span>
          <span>{{ detail.tiktokNum || "" }}</span>
        </p>
        <p>
          <span>分配来源</span>
          <span>{{ detail.latelyDistributeDetail || "" }}</span>
        </p>
        <p>
          <span>来源详情</span>
          <span>{{ detail.sourceDetail || "" }}</span>
        </p>
        <p>
          <span>分配时间</span>
          <span>{{ dateFormat(detail.latelyDistributeTime) || "--" }}</span>
        </p>
        <!-- 				<p>
					<span style="color: #1989fa;" @click="customerIntention(detail.customerIntention)">
						客户意向
						<van-icon name="edit" style="margin: 0 10px;" />
					</span>
					<span>{{ detail.customerIntention }}</span>
				</p> -->
        <p>
          <span style="color: #1989fa" @click="remarkEvemt(detail.remark)">
            备注
            <van-icon name="edit" style="margin: 0 10px" />
          </span>
          <span>{{ detail.remark }}</span>
        </p>
        <div style="font-size: 12px; color: #969799; line-height: 20px">
          <div class="customer-tags" style="font-weight: 600">信息采集</div>
          <div style="display: inline-block">
            <p>姓名：{{ getoneCustomerInfoCollect.customerName }}</p>
            <p>地区：{{ getoneCustomerInfoCollect.addressDesc }}</p>
            <p>年龄：{{ getoneCustomerInfoCollect.customerAge }}</p>
            <p>电话：{{ getoneCustomerInfoCollect.customerTel }}</p>
            <p>身份证号：{{ getoneCustomerInfoCollect.customerIdCard }}</p>
            <p>微信号：{{ getoneCustomerInfoCollect.wechatNum }}</p>
            <p>抖音号：{{ getoneCustomerInfoCollect.tiktokNum }}</p>
            <p>职务：{{ getoneCustomerInfoCollect.customerPosition }}</p>
            <p>
              学校创办时间：{{ getoneCustomerInfoCollect.schoolFoundingTime }}
            </p>
            <p>机构面积（㎡）：{{ getoneCustomerInfoCollect.orgArea }}</p>
            <p>
              机构学生数量（个）：{{ getoneCustomerInfoCollect.orgStudentNum }}
            </p>
            <p>
              机构老师数量：{{
                getoneCustomerInfoCollect.institutionalTeachersNum
              }}
            </p>
            <p>股东人数：{{ getoneCustomerInfoCollect.shareholderNum }}</p>
            <p>学科类型：{{ getoneCustomerInfoCollect.subjectTypeDesc }}</p>
            <p>学校问题：{{ getoneCustomerInfoCollect.schoolQuestionDesc }}</p>
          </div>
        </div>
        <div class="operate">
          <van-button hairline @click="handlModify">编辑</van-button>
          <van-button hairline @click="ShowCustomerInfo">详情</van-button>
          <van-button style="width: auto" hairline @click="proResearch"
            >学员档案(保密)</van-button
          >
        </div>
      </div>
      <van-button
        style="left: 0; text-align: left; padding: 0"
        size="small"
        block
        @click="$router.push({ name: 'OrderList', query: { customerId } })"
      >
        查看订单({{ detail.orderNum || 0 }})
      </van-button>

      <van-button
        style="left: 0; text-align: left; padding: 0; margin-top: 15px"
        size="small"
        block
        @click="
          $router.push({ name: 'CustomerLearned', query: { customerId } })
        "
      >
        已学课程
      </van-button>

      <van-button
        size="small"
        style="margin-top: 15px; margin-bottom: 15px"
        block
        @click="
          $router.push({
            name: 'remindList',
            query: { customerId, name: detail.customerName },
          })
        "
      >
        跟进提醒({{ noticenum || 0 }})
      </van-button>
      <div class="customer-tags">
        <p>客户意向</p>
        <div class="tags border-top border-bottom" style="--borderColor: #aaa">
          <van-radio-group
            direction="horizontal"
            v-for="(obj, index) in customerIntentions"
            :key="index"
          >
            <van-checkbox
              :name="obj.name"
              @click="chageCustomer(obj.id)"
              style="margin-top: 10px"
              v-model="obj.chose"
              checked-color="#07c160"
              >{{ obj.name }}</van-checkbox
            >
          </van-radio-group>
        </div>
      </div>
      <div class="customer-tags">
        <p>已购标签(产品)</p>
        <div class="tags border-top border-bottom" style="--borderColor: #aaa">
          <template>
            <van-tag
              round
              v-for="(nameVa, iii) in detail.projectLable"
              :key="iii"
              :type="
                nameVa.writeOffStatus === 0
                  ? 'warning'
                  : nameVa.writeOffStatus === 1
                  ? 'success'
                  : 'danger'
              "
            >
              {{ nameVa.name }}
            </van-tag>
          </template>
        </div>
      </div>
      <div class="customer-tags">
        <p>已购标签(课程)</p>
        <div class="tags border-top border-bottom" style="--borderColor: #aaa">
          <template>
            <van-tag
              round
              v-for="(nameVa, iii) in detail.courseLable"
              :key="iii"
              :type="
                nameVa.writeOffStatus === 0
                  ? 'warning'
                  : nameVa.writeOffStatus === 1
                  ? 'success'
                  : 'danger'
              "
            >
              {{ nameVa.name }}
            </van-tag>
          </template>
        </div>
      </div>
      <div class="customer-track">
        <p class="record">{{ `跟进记录(${trackList.length})` }}</p>
        <div class="track-list">
          <div class="track-item" v-for="track in trackList" :key="track.id">
            <p>{{ track.operatorName }}</p>
            <p>{{ dateFormat(track.modified) || "--" }}</p>
            <pre>{{ track.content }}</pre>
            <van-row class="img-wrap" v-if="track.image">
              <van-col
                v-for="image in track.image.split(',')"
                :key="image"
                :span="6"
              >
                <ShowImage :url="image" />
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </div>
    <div class="customer-operate">
      <van-button
        block
        @click="
          $router.push({
            name: 'CreateTrack',
            query: { id: customerId, name: detail.customerName },
          })
        "
      >
        添加跟进记录</van-button
      >
    </div>
    <!-- 客户详情 -->
    <van-popup v-model="visible" class="customer-popup" position="bottom" round>
      <div class="header border-bottom">
        <van-icon name="cross" @click="visible = false" />
        <span>{{ detail.customerName || "--" }}</span>
      </div>
      <div class="content">
        <van-cell-group
          v-for="item in tableCell"
          :title="item.title"
          :key="item.title"
        >
          <template v-if="item.children">
            <template v-for="cell in item.children">
              <van-cell
                :title="cell.title"
                :key="cell.title"
                :value="cell.slot ? '' : cell.value || '--'"
              >
                <template v-if="cell.slot">
                  <template v-if="cell.slot === 'region'">
                    <p
                      v-for="org in cell.value"
                      :key="org.id"
                      :style="{ color: '#0000ffc4' }"
                      @click="handleRegion(org)"
                    >
                      {{ org.orgName }}
                    </p>
                  </template>
                  <template v-else-if="cell.slot === 'tel'">
                    <template v-if="cell.value">
                      <a :href="`tel:${cell.value}`">{{ cell.value }}</a>
                    </template>
                    <span v-else>--</span>
                  </template>
                </template>
              </van-cell>
            </template>
          </template>
        </van-cell-group>
      </div>
      <Region
        v-if="showRegion"
        :visible.sync="showRegion"
        pattern="edit"
        :value="regioInfo"
      />
    </van-popup>
    <div v-if="isremarkshow" class="remarkBox">
      <div class="remark-shadow"></div>
      <div class="remark-content">
        <div class="titleNAme">编辑备注</div>
        <div class="textarea">
          <van-field
            v-model="remarkVal"
            rows="2"
            autosize
            type="textarea"
            maxlength="200"
            placeholder="请输入备注内容"
            show-word-limit
          />
        </div>
        <div class="bonName">
          <div class="button buttonNAme1" @click="isremarkshow = false">
            取消
          </div>
          <div class="button buttonNAme2" @click="regionEvent">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShowImage from "@/components/img/showImage";
import Region from "@/components/region";
import {
  getCustomerInfo,
  updateCustomer,
  getnoticenum,
  getfollowupstatusall,
  customerToLableSet,
  getCustomerTag,
} from "@/api/customer";
import { trackList } from "@/api/track";
import { dateFormat } from "@/utils";
import { mapGetters } from "vuex";
export default {
  name: "CustomerInfo",
  components: {
    ShowImage,
    Region,
  },
  data() {
    return {
      regioInfo: {},
      showRegion: false,
      visible: false,
      detail: {},
      trackList: [],
      showPopover: {},
      isShowPopover: false,
      isremarkshow: false,
      remarkVal: "",
      customerVal: "",
      noticenum: null,
      CustomerStatusList: [],
      value: "已接通",
      valuea: "已发送",
      valueb: "已发送",
      valuec: "已添加",
      valued: "正确",
      customerOrderFollowUp: {},
      getoneCustomerInfoCollect: {},
      customerIntention: "",
      customerIntentions: [],
    };
  },
  watch: {
    customeTag(newVal) {
      this.showPopover = newVal.reduce((acc, current) => {
        acc[current.value] = false;
        return acc;
      }, {});
    },
  },
  computed: {
    ...mapGetters(["userInfo", "customeTag"]),
    tags() {
      return (this.detail.customerToLable || []).reduce((acc, current) => {
        acc[current.type] = {
          ...current,
        };
        return acc;
      }, {});
    },
    tableCell() {
      const {
        customerTel,
        wechatNum,
        tiktokNum,
        customerIdCard,
        followUpPerson = {},
        parentName,
        customerOrg = [],
        xetUser = {},
        sourceDetail,
        source,
        created,
        remark,
      } = this.detail;
      const sourceMap = new Map([
        [1, "平台"],
        [2, "抖音小店"],
        [3, "小鹅通"],
      ]);
      return [
        {
          title: "联系信息",
          children: [
            {
              title: "手机号",
              value: customerTel,
              slot: "tel",
            },
            {
              title: "微信号",
              value: wechatNum,
            },
            {
              title: "抖音号",
              value: tiktokNum,
            },
            {
              title: "备注",
              value: remark,
            },
            {
              title: "身份证",
              value: customerIdCard,
            },
            {
              title: "跟进人",
              value: followUpPerson.name,
            },
            {
              title: "归属人",
              value: parentName || "--",
            },
            {
              title: "所属机构",
              value: customerOrg,
              slot: "region",
            },
          ],
        },
        {
          title: "来源信息",
          children: [
            {
              title: "来源",
              value: sourceMap.get(source) || "--",
            },
            {
              title: "加入时间",
              value: dateFormat(created),
            },
            {
              title: "来源详情",
              value: sourceDetail || "--",
            },
          ],
        },
        {
          title: "小鹅通用户信息",
          children: [
            {
              title: "性别",
              value: xetUser.gender
                ? xetUser.gender === 1
                  ? "男"
                  : "女"
                : "--",
            },
            {
              title: "籍贯",
              value: xetUser.province || "--",
            },
            {
              title: "来源详情",
              value: sourceDetail || "--",
            },
          ],
        },
      ];
    },
    customerId() {
      return this.$route.query.id;
    },
    hasPermisson() {
      const { roleId, id } = this.userInfo;
      return [0, 3].includes(roleId) || id === this.detail.followUpPersonId;
    },
  },
  created() {
    this.getCustomerDetails();
    this.getTrackList();
    if (!this.customeTag || !this.customeTag.length) {
      this.$store.dispatch("app/GetCustomerTag");
    }

    this.getCustomerLabel();
    getnoticenum({
      customerId: Number(this.customerId),
    }).then((res) => {
      this.noticenum = res.data.num || 0;
    });
    getfollowupstatusall().then((res) => {
      this.CustomerStatusList = res.data;
    });
  },
  methods: {
    getCustomerLabel() {
      getCustomerTag().then((res) => {
        // 按照等级排序asc
        if (res.errcode === 0) {
          res.data.sort((a, b) => {
            return a.level > b.level ? 1 : -1;
          });
          res.data.forEach((item) => {
            if (item.type === 9) {
              this.customerIntentions.push({
                name: item.name,
                id: item.id,
                chose: false,
                valueChose: false,
              });
            }
          });
        }
      });
    },
    chageCustomer(chosId) {
      this.addCustomerLableIds = [chosId];
      this.delCustomerLableIds = [];
      //看选中是否在已选中中，如果在则当删除
      for (const key in this.customerIntentions) {
        if (this.customerIntentions[key].id == chosId) {
          if (this.customerIntentions[key].valueChose == true) {
            this.delCustomerLableIds = [chosId];
            this.customerIntentions[key].chose = false;
            this.customerIntentions[key].valueChose = false;
            this.addCustomerLableIds = [];
          }
        }
      }
      customerToLableSet({
        customerId: Number(this.customerId),
        addCustomerLableIds: this.addCustomerLableIds,
        delCustomerLableIds: this.delCustomerLableIds,
      }).then((res) => {
        if (res.errcode === 0) {
          this.$toast("保存成功！");
          this.getCustomerDetails();
        }
      });
    },
    customerEvent() {
      console.log(this.customerVal);
    },
    remarkEvemt(val) {
      this.remarkVal = val;
      this.isremarkshow = true;
    },
    regionEvent() {
      updateCustomer({
        id: Number(this.customerId),
        remark: this.remarkVal,
      }).then(() => {
        this.getCustomerDetails();
        this.isremarkshow = false;
      });
    },
    ShowCustomerInfo() {
      this.visible = true;
      // 查询客户详情
    },
    proResearch() {
      if (process.env.VUE_APP_BASE_URL == "https://api.zhiwuhui.net") {
        this.$copyText(
          "https://m.zhiwuhui.net/proResearch?customerId=" +
            this.customerId +
            "&captchaId=" +
            this.detail.getoneCustomerInfoCollect.captchaId
        ).then((res) => {
          this.$toast("学员档案地址复制成功");
        });
      } else {
        this.$copyText(
          "https://mtest.zhiwuhui.net/proResearch?customerId=" +
            this.customerId +
            "&captchaId=" +
            this.detail.getoneCustomerInfoCollect.captchaId
        ).then((res) => {
          this.$toast("学员档案地址复制成功");
        });
      }
    },
    getCustomerDetails() {
      // 查询客户详情
      getCustomerInfo({
        id: Number(this.customerId),
      }).then((res) => {
        if (res.errcode === 0) {
          // const lableName = []
          // res.data.projectLable.forEach(pp => {
          //   lableName.push(pp.projectLableName)
          // })
          // res.data.lableName = lableName.join(', ')
          this.detail = res.data;
          console.log(this.detail.followUpPerson);
          this.getoneCustomerInfoCollect = res.data.getoneCustomerInfoCollect;
          // this.customerIntention = res.data.customerIntention
          this.customerOrderFollowUp = res.data.customerOrderFollowUp;
          this.customerOrderFollowUp.telConnectionStatus === "1"
            ? (this.value = "已接通")
            : (this.value = "未接通");
          this.customerOrderFollowUp.sendSmsStatus === "1"
            ? (this.valuea = "已发送")
            : (this.valuea = "未发送");
          this.customerOrderFollowUp.sendDataStatus === "1"
            ? (this.valueb = "已发送")
            : (this.valueb = "未发送");
          this.customerOrderFollowUp.addCustomerStatus === "1"
            ? (this.valuec = "已添加")
            : (this.valuec = "未添加");
          this.customerOrderFollowUp.contactInfoStatus === "1"
            ? (this.valued = "正确")
            : (this.valued = "错误");

          res.data.customerToLable.forEach((tag) => {
            for (const key in this.customerIntentions) {
              if (this.customerIntentions[key].id === tag.customerLableId) {
                this.customerIntentions[key].chose = true;
                this.customerIntentions[key].valueChose = true;
              }
            }
          });
        }
      });
    },
    getTrackList() {
      trackList({
        page: 1,
        count: 2000,
        customerId: Number(this.customerId),
      }).then((res) => {
        if (res.errcode === 0) {
          this.trackList = res.data;
        }
      });
    },
    dateFormat,
    handlModify() {
      // 编辑客户
      if (!this.hasPermisson) {
        this.$toast("只有管理人员和跟进人可以编辑用户");
        return;
      }
      this.$router.push({
        name: "CreateCustomer",
        query: {
          customerId: this.customerId,
        },
      });
    },
    handleRegion(item) {
      const {
        orgNum = "",
        orgName = "",
        orgAddress = "",
        lng = undefined,
        lat = undefined,
      } = item;
      this.regioInfo = {
        orgNum,
        orgName,
        orgAddress,
        lng,
        lat,
      };
      this.showRegion = true;
    },
    handleEditTag(tag, item) {
      // console.log(789, JSON.parse(JSON.stringify(tag)), JSON.parse(JSON.stringify(item)))
      // 编辑标签
      this.showPopover[tag.value] = false;
      this.isShowPopover = false;
      const customerLableIds = [];
      this.customeTag.forEach((val) => {
        if (this.tags[val.value]) {
          // 当客户存在此标签时
          if (this.tags[val.value].customerLableId !== item.id) {
            // 如果与之前标签一致，则不添加改标签
            const id =
              tag.value === val.value
                ? item.id
                : this.tags[val.value].customerLableId;
            customerLableIds.push(id);
          }
        } else if (tag.value === val.value) {
          // 客户不存在标签，则直接新增
          customerLableIds.push(item.id);
        }
      });

      this.CustomerStatusList.length;

      if (this.CustomerStatusList[0].type === item.type) {
        customerLableIds.push(item.id);
      } else {
        this.detail.followUpStatusName.forEach((tt) => {
          customerLableIds.push(tt.customerLableId);
        });
      }

      const params = {
        id: Number(this.customerId),
        customerLableIds,
      };
      updateCustomer(params).then((res) => {
        if (res.errcode === 0) {
          this.getCustomerDetails();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-radio-button {
  position: relative;
  outline: 0;
}
.el-radio-button__inner {
  border-radius: 14px;
  border-left: 1px solid #dcdfe6;
  border-radius: 4px 0 0 4px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  white-space: nowrap;
  background: #fff;
  border: 1px solid #dcdfe6;
  font-weight: 500;
  border-left: 0;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  position: relative;
  cursor: pointer;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 0;
}
.van-tag--warning {
  background-color: #ff9900;
}
.van-tag--danger {
  background-color: red;
}
.van-tag--success {
  background-color: green;
}
.customer {
  margin-bottom: 10px;

  .van-button {
    color: #1989fa;
  }

  &-main {
    .customer {
      &-info {
        padding: 10px 16px;
        background-color: #fff;

        p {
          display: flex;
          justify-content: space-between;

          &:not(:first-of-type) {
            font-size: 12px;
            color: #969799;
            line-height: 20px;
          }
        }

        .operate {
          margin-top: 15px;
          display: flex;
          justify-content: space-around;

          .van-button {
            color: #969799;
            height: 24px;
            width: 96px;
            border-color: #969799;
          }
        }

        .region-info {
          span {
            color: #969799;
            font-size: 12px;
          }
        }
      }

      &-tags {
        p {
          font-size: 12px;
          line-height: 20px;
          padding: 5px 16px;
          color: #969799;
        }

        .tags {
          padding: 10px;
          background-color: #fff;

          .van-tag {
            margin-right: 5px;
            margin-bottom: 5px;
          }
        }
      }

      &-track {
        p {
          font-size: 12px;
          color: #969799;
        }

        .record {
          padding: 10px 16px;
        }

        .track-item {
          background-color: #fff;
          padding: 10px;
          margin-bottom: 10px;

          p {
            color: #969799;
            line-height: 20px;

            &:first-of-type {
              font-size: 14px;
            }
          }

          pre {
            color: #969799;
            line-height: 20px;
            margin: 0;
          }
        }

        .img-wrap {
          margin-top: 10px;

          .van-col {
            padding-right: 10px;
          }
        }
      }
    }
  }

  &-popup {
    height: 70%; // 客户详情信息

    .header {
      padding: 10px 20px;
      text-align: center;
      line-height: 30px;

      .van-icon-cross {
        float: left;
        cursor: pointer;
        line-height: 30px;
      }
    }

    .content {
      .van-cell-group {
        &__title {
          padding: 16px;
        }

        .van-cell {
          font-size: 12px;
        }
      }
    }
  }
}

.popover {
  .active {
    background-color: #ecf5ff;
    color: #409eff;
  }

  li {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 16px;
    height: 44px;
    width: 128px;
    font-size: 14px;

    &:not(:last-child) {
      &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        right: 0;
        bottom: 0;
        border-top: 1px solid var(--borderColor, #ebedf0);
        transform: scaleY(0.5);
        z-index: 100;
      }
    }
  }
}

.remarkBox {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 999;

  .remark-shadow {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 100;
    background: #333333;
    opacity: 0.6;
  }

  .remark-content {
    border-radius: 5px;
    position: fixed;
    left: 10%;
    right: 10%;
    width: 80%;
    height: 35%;
    top: 20%;
    z-index: 130;
    background: #ffffff;

    .titleNAme {
      padding-left: 10px;
      height: 20%;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      border-bottom: 1px solid #e5e5e5;
    }

    .textarea {
      border-bottom: 1px solid #e5e5e5;
    }

    .bonName {
      height: 40%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;

      .button {
        width: 30%;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
      }

      .buttonNAme1 {
        color: #323233;
        border: 1px solid #ebedf0;
      }

      .buttonNAme2 {
        color: #ffffff;
        background: #07c160;
        border: 1px solid #07c160;
      }
    }
  }
}
</style>
